import React from 'react'
//import { Link } from 'react-router-dom'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { destinosAPI } from '../../utils/funcionesAPI'
import { manejadorDeRespuesta } from '../../utils/Tools'

//SUMAR DÍAS A UN OBJETO FECHA.
Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

//RESTAR DÍAS A UN OBJETO FECHA.
Date.prototype.substractDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
}

class Filtros extends React.Component {
  constructor(props) {
      super(props)
      this.state = {
                    fechaMinima: new Date(),
                    fechaMaxima: new Date().addDays(30),
                    startDate: new Date(),
                    mesElegido: '',
                    destinoElegido: '',
                    estadoElegido: '1',
                    destinos:[]
      };

      this.handleFiltrarPorEstadoClick = this.handleFiltrarPorEstadoClick.bind(this);
      this.handleFiltrarPorMesClick = this.handleFiltrarPorMesClick.bind(this);
      this.handleFiltrarPorDestinoClick = this.handleFiltrarPorDestinoClick.bind(this);
      this.handleFiltrarPorFecha = this.handleFiltrarPorFecha.bind(this);
  }

  //FC: se ejecuta una vez renderizado el DOM, ideal para meter DATA y/o manipularlo
  componentDidMount() {
    this.traerDestinos();
  }

  formatDate(date){
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    day = day < 10 ? `0${day}` : day;
    month = month < 10 ? `0${month}` : month;
    return `${year}-${month}-${day}`;
  }

  cambiarFechaMaxima = (name, event) => {
    let date = event.target.value;
    this.setState({fechaMaxima: new Date(date).addDays(30)});
  }

  traerDestinos() {
      var _this = this;
      //const token = sessionStorage.getItem('token');

      let data = JSON.stringify({peticion: 'traerDestinos'});

      destinosAPI(data)
              .then(respuesta => {
                if (manejadorDeRespuesta(_this.props, respuesta))
                    _this.setState({destinos: respuesta.data});
              });
  }

  blanquearCampos() {
    const e = {value: '0'};
    this.setState({estadoElegido: '', mesElegido: '', destinoElegido: ''});
    this.props.onFiltrarPorEstado(e);
  }


  handleFiltrarPorEstadoClick(e) {
    if (!e) {
      this.blanquearCampos();
    } else {
      this.setState({estadoElegido: e.value, mesElegido: '', destinoElegido: ''});
      this.props.onFiltrarPorEstado(e);
    }
  }

  handleFiltrarPorMesClick(e) {
    if (!e) {
      this.blanquearCampos();
    } else {
      this.setState({mesElegido: e.value, destinoElegido: '', estadoElegido: ''});
      this.props.onFiltrarPorMes(e);
    }
  }

  handleFiltrarPorDestinoClick(e) {
    if (!e) {
      this.blanquearCampos();
    } else {
      this.setState({destinoElegido: e.value, mesElegido: '', estadoElegido: ''});
      this.props.onFiltrarPorDestino(e);
    }

  }

  handleFiltrarPorFecha(e){
    var fechaMin = document.getElementById('fechaMin').value;
    this.props.onPaqueteClick(fechaMin);
  }

render() {

    let destinosParaSelect = [{value: '0', label: 'TODOS', className:'optionsDelBuscador'}];

    this.state.destinos.forEach(function(destino) {
      destinosParaSelect.push({value: destino.idDestino, label: destino.descripcion, className:'optionsDelBuscador'})
    });



  return (
      <div style={{display: 'contents'}}>
          <div className="sort-bar col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <span>Consultar reserva desde fecha: </span>
            <input id="fechaMin" name="fechaMin" type="date" onChange={this.cambiarFechaMaxima.bind(this, 'fechaMin')} style={{marginRight: '20px', borderRadius: '5px'}}/>
            <input id="fechaMax" type="date" value={this.formatDate(this.state.fechaMaxima)} disabled style={{marginRight: '20px', borderRadius: '5px'}} />
            <button className="btnMisReservas" onClick={this.handleFiltrarPorFecha}>Buscar</button>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <span>Consultar resultados por: </span>
              <div className="btn-group">
                <Select
                    className="buscadorDestinos"
                    placeholder="Mes"
                    name="form-field-name"
                    value={this.state.mesElegido}
                    onChange={this.handleFiltrarPorMesClick}
                    options={[
                      {value: '0', label: 'Todos', className:'optionsDelBuscador'},
                      {value: 'Enero', label: 'Enero', className:'optionsDelBuscador'},
                      {value: 'Febrero', label: 'Febrero', className:'optionsDelBuscador'},
                      {value: 'Marzo', label: 'Marzo', className:'optionsDelBuscador'},
                      {value: 'Abril', label: 'Abril', className:'optionsDelBuscador'},
                      {value: 'Mayo', label: 'Mayo', className:'optionsDelBuscador'},
                      {value: 'Junio', label: 'Junio', className:'optionsDelBuscador'},
                      {value: 'Julio', label: 'Julio', className:'optionsDelBuscador'},
                      {value: 'Agosto', label: 'Agosto', className:'optionsDelBuscador'},
                      {value: 'Septiembre', label: 'Septiembre', className:'optionsDelBuscador'},
                      {value: 'Octubre', label: 'Octubre', className:'optionsDelBuscador'},
                      {value: 'Noviembre', label: 'Noviembre', className:'optionsDelBuscador'},
                      {value: 'Diciembre', label: 'Diciembre', className:'optionsDelBuscador'},
                    ]}
                  />
              </div>

              <div className="btn-group">
                <Select
                    className="buscadorDestinos"
                    placeholder="Destinos"
                    name="form-field-name"
                    value={this.state.destinoElegido}
                    onChange={this.handleFiltrarPorDestinoClick}
                    options={destinosParaSelect}
                  />
              </div>

              <div className="btn-group">
                <Select
                    className="buscadorDestinos"
                    placeholder="Estado"
                    name="form-field-name"
                    value={this.state.estadoElegido}
                    onChange={this.handleFiltrarPorEstadoClick}
                    options={[
                      {value: '0', label: 'Todos', className:'optionsDelBuscador'},
                      {value: '1', label: 'Activos', className:'optionsDelBuscador'},
                      {value: '9', label: 'Cancelados', className:'optionsDelBuscador'}
                    ]}
                  />
              </div>

              {/*
              <div className="btn-group">
                <button className="btnMisReservas" onClick={this.props.onPaqueteClick}>Paquetes</button>
              </div>
              <div className="btn-group">
                <button className="btnMisReservas" onClick={this.props.onCDRClick}>Hoteles</button>

              </div>
              */}
          </div>
      </div>
  )
}
}

export default Filtros



// WEBPACK FOOTER //
// ./src/components/MisReservas/Filtros.js